import { put, takeLatest } from 'redux-saga/effects';
import { GetLicenseDetails } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk } }) {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/GetLicenseDetails/' + pk, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const requestResult = yield response.json();
        


        yield put(GetLicenseDetails.creators.getLicenseDetailsSuccess({ licenza: requestResult } ));

    } catch (e) {
        yield put(GetLicenseDetails.creators.getLicenseDetailsFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(GetLicenseDetails.types.GET_DETTAGLI_LICENZA_REQUEST, runAction);
}